import creak1 from '../../assets/sounds/creak1.mp3';
import creak2 from '../../assets/sounds/creak2.mp3';
import doorClose1 from '../../assets/sounds/doorClose_1.mp3';
import doorClose2 from '../../assets/sounds/doorClose_2.mp3';
import doorClose3 from '../../assets/sounds/doorClose_3.mp3';
import doorClose4 from '../../assets/sounds/doorClose_4.mp3';
import doorOpen1 from '../../assets/sounds/doorOpen_1.mp3';
import doorOpen2 from '../../assets/sounds/doorOpen_2.mp3';
import footstepCarpet000 from '../../assets/sounds/footstep_carpet_000.mp3';
import footstepCarpet001 from '../../assets/sounds/footstep_carpet_001.mp3';
import footstepCarpet002 from '../../assets/sounds/footstep_carpet_002.mp3';
import footstepCarpet003 from '../../assets/sounds/footstep_carpet_003.mp3';
import footstepCarpet004 from '../../assets/sounds/footstep_carpet_004.mp3';
import footstepConcrete000 from '../../assets/sounds/footstep_concrete_000.mp3';
import footstepConcrete001 from '../../assets/sounds/footstep_concrete_001.mp3';
import footstepConcrete002 from '../../assets/sounds/footstep_concrete_002.mp3';
import footstepConcrete003 from '../../assets/sounds/footstep_concrete_003.mp3';
import footstepConcrete004 from '../../assets/sounds/footstep_concrete_004.mp3';
import footstepWood000 from '../../assets/sounds/footstep_wood_000.mp3';
import footstepWood001 from '../../assets/sounds/footstep_wood_001.mp3';
import footstepWood002 from '../../assets/sounds/footstep_wood_002.mp3';
import footstepWood003 from '../../assets/sounds/footstep_wood_003.mp3';
import footstepWood004 from '../../assets/sounds/footstep_wood_004.mp3';
import impactGlassLight000 from '../../assets/sounds/impactGlass_light_000.mp3';
import impactGlassLight001 from '../../assets/sounds/impactGlass_light_001.mp3';
import impactMetalLight000 from '../../assets/sounds/impactMetal_light_000.mp3';
import impactWoodLight000 from '../../assets/sounds/impactWood_light_000.mp3';
import impactWoodLight001 from '../../assets/sounds/impactWood_light_001.mp3';
import metalClick from '../../assets/sounds/metalClick.mp3';
import metalLatch from '../../assets/sounds/metalLatch.mp3';

const GROUPS = {
  footWood: [footstepWood000, footstepWood001, footstepWood002, footstepWood003, footstepWood004],
  footHard: [footstepConcrete000, footstepConcrete001, footstepConcrete002, footstepConcrete003, footstepConcrete004],
  footCarpet: [footstepCarpet000, footstepCarpet001, footstepCarpet002, footstepCarpet003, footstepCarpet004],
  doorOpen: [doorOpen1, doorOpen2],
  doorClose: [doorClose1, doorClose2, doorClose3, doorClose4],
  creak: [creak1, creak2],
  latch: [metalLatch],
  click: [metalClick],
  glassKnock: [impactGlassLight000, impactGlassLight001],
  woodKnock: [impactWoodLight000, impactWoodLight001],
  metalKnock: [impactMetalLight000],
};

// ---------------------------------------------------------------------------------------------------
// صداهای حالتِ اول‌شخص: قدم‌ها (بسته به جنسِ کف) و باز/بسته‌شدنِ در و پنجره (بسته به مدل و جنس).
// فایل‌ها از دو بسته‌ی رایگانِ Kenney (Impact Sounds و RPG Audio) هستند — لایسنس CC0 (استفاده‌ی آزاد، حتی
// تجاری؛ ذکرِ نام اختیاری است) — و برای پخش روی همه‌ی گوشی‌ها (از جمله آیفون‌های قدیمی که OGG ندارند)
// به MP3 تبدیل شده‌اند.
//
// مرورگرها پخشِ صدا را تا اولین لمسِ کاربر اجازه نمی‌دهند؛ unlockAudio() را در هر لمس صدا بزنید (بی‌هزینه
// است وقتی از قبل باز شده باشد). اگر مرورگر Web Audio نداشته باشد، همه‌ی توابع بی‌صدا و بی‌خطا کار می‌کنند.

// بلندیِ پایه‌ی هر گروه — فایل‌ها بلندیِ متفاوتی دارند (درِ بسته‌شدن حدودِ ۴dB بلندتر، کلیکِ فلزی خیلی
// آرام‌تر)، این‌جا یکسان‌سازی و بعد نسبت‌ها تنظیم شده‌اند: قدم‌ها آرام‌تر از صدای در
const GROUP_GAIN = {
  footWood: 0.32,
  footHard: 0.3,
  footCarpet: 0.4,
  doorOpen: 0.55,
  doorClose: 0.36,
  creak: 0.5,
  latch: 0.4,
  click: 1.4,
  glassKnock: 0.28,
  woodKnock: 0.35,
  metalKnock: 0.25,
};

const MASTER_GAIN = 0.9;
// زمانِ رسیدنِ لنگه‌ی در/پنجره به چارچوب هنگامِ بسته شدن (هر دو با سرعتِ انیمیشنِ ۶ در Door3D/Window3D، حدودِ
// ۹۵٪ مسیر در این زمان طی می‌شود) — صدای «خوردن به چارچوب» همین لحظه پخش می‌شود، نه لحظه‌ی لمس
const CLOSE_IMPACT_DELAY_S = 0.45;

let ctx = null;
let master = null;
let enabled = true;
const buffers = new Map(); // url → AudioBuffer
const loading = new Map(); // url → Promise
const lastIndex = new Map(); // گروه → آخرین فایلِ پخش‌شده (تا یک صدا دو بار پشتِ‌سرِ‌هم تکرار نشود)

function getContext() {
  if (ctx) return ctx;
  const AC = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
  if (!AC) return null;
  ctx = new AC();
  master = ctx.createGain();
  master.gain.value = MASTER_GAIN;
  master.connect(ctx.destination);
  return ctx;
}

function load(url) {
  if (buffers.has(url)) return Promise.resolve(buffers.get(url));
  if (loading.has(url)) return loading.get(url);
  const c = getContext();
  if (!c) return Promise.resolve(null);
  const p = fetch(url)
    .then((r) => r.arrayBuffer())
    .then((data) => new Promise((resolve, reject) => c.decodeAudioData(data, resolve, reject)))
    .then((buf) => {
      buffers.set(url, buf);
      loading.delete(url);
      return buf;
    })
    .catch(() => {
      loading.delete(url);
      return null;
    });
  loading.set(url, p);
  return p;
}

// در اولین لمس/کلیکِ کاربر صدا زده شود — AudioContext را می‌سازد/ادامه می‌دهد و همه‌ی صداها را از قبل لود
// می‌کند (مجموعاً حدودِ ۱۸۰ کیلوبایت) تا اولین قدم بدونِ تأخیر شنیده شود
export function unlockAudio() {
  const c = getContext();
  if (!c) return;
  if (c.state === 'suspended') c.resume().catch(() => {});
  Object.values(GROUPS).forEach((list) => list.forEach((url) => load(url)));
}

export function setSoundEnabled(value) {
  enabled = Boolean(value);
}

export function isSoundEnabled() {
  return enabled;
}

function pickUrl(group) {
  const list = GROUPS[group];
  if (!list || !list.length) return null;
  let i = Math.floor(Math.random() * list.length);
  if (list.length > 1 && i === lastIndex.get(group)) i = (i + 1) % list.length;
  lastIndex.set(group, i);
  return list[i];
}

// پخشِ یک صدا از یک گروه. rate: سرعت/زیریِ پخش (با کمی تغییرِ تصادفی تا تکراری نشود). delay: ثانیه
function play(group, { gain = 1, rate = 1, delay = 0, jitter = 0.05 } = {}) {
  if (!enabled) return;
  const c = getContext();
  if (!c) return;
  const url = pickUrl(group);
  if (!url) return;
  const start = (buf) => {
    if (!buf || !enabled) return;
    const src = c.createBufferSource();
    src.buffer = buf;
    src.playbackRate.value = rate * (1 + (Math.random() * 2 - 1) * jitter);
    const g = c.createGain();
    g.gain.value = (GROUP_GAIN[group] ?? 0.5) * gain * (1 + (Math.random() * 2 - 1) * 0.08);
    src.connect(g);
    g.connect(master);
    src.start(c.currentTime + Math.max(0, delay));
  };
  const buf = buffers.get(url);
  if (buf) start(buf);
  else load(url).then(start); // اگر هنوز لود نشده، به‌محضِ آماده‌شدن
}

// --- قدم‌ها ---------------------------------------------------------------------------------------------
// جنسِ کف (floorStyle.type در Floor3D.jsx) → نوعِ صدای قدم. چوب/لمینت/پارکت = چوب؛ موکت = موکت؛ بقیه (سرامیک،
// سنگ، تراورتن، بتن، کفِ رنگ‌شده) = سطحِ سخت، با زیریِ کمی متفاوت: سرامیک و سنگِ صیقلی تیزتر، بتن بم‌تر
const FOOTSTEP_BY_FLOOR = {
  parquetPbr: { group: 'footWood', rate: 1 },
  laminateLightPbr: { group: 'footWood', rate: 1.05 },
  laminateDarkPbr: { group: 'footWood', rate: 1.05 },
  carpetPbr: { group: 'footCarpet', rate: 1 },
  ceramicPbr: { group: 'footHard', rate: 1.12 },
  stoneSlabPbr: { group: 'footHard', rate: 1.08 },
  stonePbr: { group: 'footHard', rate: 1.04 },
  travertinePbr: { group: 'footHard', rate: 1.02 },
  concretePbr: { group: 'footHard', rate: 0.95 },
  paint: { group: 'footHard', rate: 0.98 },
};

export function playFootstep(floorType) {
  const f = FOOTSTEP_BY_FLOOR[floorType] || FOOTSTEP_BY_FLOOR.paint;
  play(f.group, { rate: f.rate, jitter: 0.06 });
}

// --- در -----------------------------------------------------------------------------------------------
const SLIDING_DOOR_TYPES = ['sliding', 'doubleSliding', 'barn'];
const GLASS_DOOR_TYPES = ['glassModern', 'french', 'sliding'];

// style: خروجیِ resolveDoorStyle (type و material). opening: true = دارد باز می‌شود
export function playDoorSound(style, opening) {
  const type = style?.type || 'single';
  const material = style?.material || 'paint';
  const isMetal = material === 'metalBrushed';
  const isGlass = GLASS_DOOR_TYPES.includes(type);

  if (SLIDING_DOOR_TYPES.includes(type)) {
    // کشویی/ریلی: بدونِ لولا — فقط قفل/دستگیره و خوردنِ نرم به انتهای ریل
    if (opening) {
      play('click', { rate: 1.1 });
      if (type === 'barn') play('creak', { rate: 0.65, gain: 0.45, delay: 0.05 }); // غلتیدنِ قرقره روی ریل
    } else {
      play(isGlass ? 'glassKnock' : 'woodKnock', { delay: CLOSE_IMPACT_DELAY_S, gain: 0.9 });
      play('click', { delay: CLOSE_IMPACT_DELAY_S + 0.05 });
    }
    return;
  }

  // درهای لولایی (یک‌تیکه، دوتیکه، مدرن، فرانسوی، قدیمی، تاشو)
  if (opening) {
    play('latch', { gain: 0.8 });
    play('doorOpen', { delay: 0.06, rate: type === 'folding' ? 1.15 : 1 });
    if (type === 'classic') play('creak', { delay: 0.12 }); // درِ قدیمی: قیژ
  } else {
    play('doorClose', { delay: CLOSE_IMPACT_DELAY_S - 0.08, rate: isGlass ? 1.08 : 1 });
    if (isGlass) play('glassKnock', { delay: CLOSE_IMPACT_DELAY_S, gain: 0.7 });
    if (isMetal) play('metalKnock', { delay: CLOSE_IMPACT_DELAY_S });
    if (type === 'double') play('doorClose', { delay: CLOSE_IMPACT_DELAY_S + 0.05, gain: 0.6 }); // لنگه‌ی دوم
  }
}

// --- پنجره --------------------------------------------------------------------------------------------
// style: خروجیِ resolveWindowStyle (type و material)
export function playWindowSound(style, opening) {
  const type = style?.type || 'sliding';
  const material = style?.material || 'paint';
  const frameKnock = material === 'woodPine' || material === 'woodDark' ? 'woodKnock' : material === 'metalBrushed' ? 'metalKnock' : null;

  if (opening) {
    play('latch', { rate: 1.1, gain: 0.8 }); // دستگیره‌ی پنجره
    if (type === 'sliding') play('click', { delay: 0.1 });
  } else {
    play('glassKnock', { delay: CLOSE_IMPACT_DELAY_S });
    if (frameKnock) play(frameKnock, { delay: CLOSE_IMPACT_DELAY_S, gain: 0.7 });
    play('latch', { delay: CLOSE_IMPACT_DELAY_S + 0.12, rate: 1.15, gain: 0.7 }); // قفل‌شدن
  }
}
